module.exports = __webpack_public_path__ + "img/gan_rina_yes.9acc9576.png";